module.exports = {
  businessNumber: 'เลขที่ธุรกิจ',
  businessType: 'ประเภทธุรกิจ',
  mblNo: 'เลขที่เอกสารหลัก',
  customer: 'ลูกค้า',
  carrier: 'ผู้ขนส่ง',
  vessel: 'ชื่อเรือ',
  shippingCompanyContractNo: 'เลขที่สัญญาบริษัทเรือ',
  voyageFlight: 'เที่ยวบิน/เที่ยวเรือ',
  SeaPortOfLoading: 'ท่าเรือต้นทาง/ท่าเรือบรรทุก',
  portOfDestination: 'ท่าเรือปลายทาง',
  dischargingPortCode: 'ท่าเรือขนถ่าย',
  dateOfDeparture: 'วันที่ออกเรือ',
  businessDate: 'วันที่ทำธุรกิจ',
  businessReferenceNumber: 'เลขที่อ้างอิงธุรกิจ',
  bookingAgent: 'ตัวแทนจองพื้นที่',
  dateOfCreation: 'วันที่สร้าง',
  dateOfProof: 'วันที่เอกสาร',
  operation: 'การดำเนินการ',
  sales: 'ฝ่ายขาย',
  salesDepartment: 'แผนกขาย',
  CustomerService: 'บริการลูกค้า',
  Documents: 'เอกสาร',
  accrued: 'ได้บันทึกแล้ว',
  status: 'สถานะ',
  actualChargedWeight: 'น้ำหนักคิดค่าบริการจริง',
  profit: 'กำไร',
  totalIncome: 'รายได้รวม',
  totalCost: 'ต้นทุนรวม',
  closingAccountStatus: 'สถานะการโอนย้าย',
  hasReceivable: 'บังคับโอนย้ายหรือไม่',
  profitExcludingTax: 'กำไร (ไม่รวมภาษี)',
  totalIncomeExcludingTax: 'รายได้ (ไม่รวมภาษี)',
  totalCostExcludingTax: 'ต้นทุน (ไม่รวมภาษี)',
  profitClosingAccount: 'กำไรรอโอนย้าย',
  totalIncomeClosingAccount: 'รายได้รอโอนย้าย',
  totalCostClosingAccount: 'ต้นทุนรอโอนย้าย',
  hasReceivableTotal: 'บังคับบันทึกหรือไม่',
  profitCommission: 'กำไรค่าคอมมิชชั่นครั้งนี้',
  totalIncomeCommission: 'รายได้ค่าคอมมิชชั่นครั้งนี้',
  totalCostCommission: 'ต้นทุนค่าคอมมิชชั่นครั้งนี้',
  provisionedStatus: 'สถานะการบันทึก',
  refundCommission: 'ค่าคอมมิชชั่น',
  closingAccountRevenue: 'รายได้ที่โอนย้ายแล้ว',
  closingAccountCost: 'ต้นทุนที่โอนย้ายแล้ว',
  invoiceCost: 'ต้นทุนที่ได้รับใบเสร็จแล้ว',
  payablesWriteOfStatus: 'สถานะการตรวจสอบเจ้าหนี้',
  receivablesWriteOfStatus: 'สถานะการตรวจสอบลูกหนี้',
  payablesConfirmOfStatus: 'สถานะยืนยันค่าใช้จ่ายเจ้าหนี้',
  receivablesConfirmOfStatus: 'สถานะยืนยันค่าใช้จ่ายลูกหนี้',
  accrualDate: 'วันที่บันทึก',
  creator: 'ผู้สร้างธุรกิจ',
  receivables: 'ลูกหนี้',
  payables: 'เจ้าหนี้',
  englishDescriptionOfGoods: 'ชื่อสินค้า (ภาษาอังกฤษ)',
  chineseDescriptionOfGoods: 'ชื่อสินค้า (ภาษาจีน)',
  consignationCompany: 'หน่วยมอบหมาย',
  settlementCompany: 'หน่วยชำระเงิน',
  destinationAgent: 'ตัวแทนท่าปลายทาง',
  nominatedAgent: 'ตัวแทนสินค้าที่กำหนด',
  destinationAgentShortName: 'ตัวแทนท่าปลายทาง (ย่อ)',
  nominatedAgentShortName: 'ตัวแทนสินค้าที่กำหนด (ย่อ)',
  containerNo: 'หมายเลขตู้',
  amountRange: 'ช่วงจำนวนเงิน',
  profitRange: 'ช่วงกำไร',
  localAmountRange: 'ช่วงจำนวนเงินที่แปลงเป็นสกุลเงินหลัก',
  SubmissionDateTime: 'เวลาส่ง',
  AuditDateTime: 'เวลาตรวจสอบ',
  feeStatus: 'สถานะค่าใช้จ่าย',
  redChargesOrNot: 'มีการยกเลิกหรือไม่',
  portOfLoading: 'ท่าเรือบรรทุก/ท่าเรือเริ่มต้น',
  AirPortOfLoading: 'ท่าเรือบรรทุก/ท่าเรือเริ่มต้น (สนามบิน)',
  seaportOfDischarge: 'ท่าเรือขนถ่าย (ท่าเรือ)',
  airportOfDischarge: 'ท่าเรือขนถ่าย (สนามบิน)',
  airportOfDestination: 'ท่าปลายทาง (สนามบิน)',
  operationDepartment: 'ฝ่ายปฏิบัติการ',
  invoiceDate: 'วันที่ออกใบแจ้งหนี้',
  invoiceDateAR: 'วันที่ออกใบแจ้งหนี้ลูกหนี้',
  financialaDate: 'วันที่ทางการเงิน',
  solicitationType: 'ประเภทการรับสินค้า',
  warehouseNo: 'หมายเลขคลังสินค้า',
  itemNo: 'หมายเลขโครงการ',
  receivablesInvoicingStatus: 'สถานะการออกใบแจ้งหนี้',
  receivablesInvoicingStatusAr: 'สถานะการออกใบแจ้งหนี้ลูกหนี้',
  businessStatus: 'สถานะธุรกิจ',
  customJobType: 'ประเภทธุรกิจที่กำหนดเอง',
  separateNumber: 'หมายเลขใบแบ่ง',
  containerDescription: 'คำอธิบายปริมาณตู้',
  designationAgent: 'ตัวแทนสินค้าที่กำหนด',
  masterBLFreightTerm: 'เงื่อนไขค่าขนส่งหลัก',
  HBLFreightClause: 'เงื่อนไขค่าขนส่งใบแบ่ง',
  IncoTerm: 'เงื่อนไขการค้า',
  FLCLType: 'ประเภทการรวม/แยก',
  SeaExportFLCLType: 'ประเภทการรวม/แยก (ส่งออกทางทะเล)',
  SeaImportFLCLType: 'ประเภทการรวม/แยก (นำเข้าทางทะเล)',
  OperateType: 'โหมดปฏิบัติการ',
  AirExportOperateType: 'โหมดปฏิบัติการ (ส่งออกทางอากาศ)',
  AirImportOperateType: 'โหมดปฏิบัติการ (นำเข้าทางอากาศ)',
  UserDefinedField1: 'ฟิลด์ที่กำหนดเอง 1',
  UserDefinedField2: 'ฟิลด์ที่กำหนดเอง 2',
  UserDefinedField3: 'ฟิลด์ที่กำหนดเอง 3',
  ManageAuditStatus: 'สถานะการตรวจสอบกำไร',
  paymentRequestNumber: 'เลขที่ใบคำร้องขอชำระเงิน',
  placeOfDelivery: 'สถานที่ส่งมอบ',
  changeState: 'สถานะการแก้ไขเอกสาร',
  grossProfitRate: 'อัตรากำไรขั้นต้น',
  railwayTransportLine: 'เส้นทาง (ทางรถไฟ)',
  route: 'เส้นทาง',
  exportLoadingPlan: 'ส่งออกแผนการบรรจุ',
  exportSalesReport: 'ส่งออกรายงานการขาย',
  moreOperations: 'การดำเนินการเพิ่มเติม',
  routeOperation: 'การดำเนินการเส้นทาง',
  completeBooking: 'การจองห้องโดยสารเสร็จสิ้น',
  warehousing: 'นำเข้าคลัง',
  mountingBoard: 'การบรรจุ',
  pullGood: 'การดึงสินค้า',
  applicationForFlightAdjustment: 'ขอปรับเที่ยวบิน',
  allocateFlights: 'การจัดสรรเที่ยวบิน',
  confirmCabinAllocation: 'ยืนยันการจัดห้องโดยสาร',
  cancelConfirmationOfCabinAllocation: 'ยกเลิกการยืนยันการจัดห้องโดยสาร',
  copyIncomingData: 'คัดลอกข้อมูลนำเข้าคลัง',
  otherRemarks: 'หมายเหตุอื่น ๆ',
  otherExpenses: 'ค่าใช้จ่ายอื่น ๆ',
  delivery: 'การส่งมอบ',
  deliveryAgent: 'ตัวแทนส่งมอบ',
  uploadBoardPhotos: 'อัปโหลดรูปภาพการบรรจุ',
  subLabel: 'ป้ายแยก',
  prefabricatedMasterOrder: 'เอกสารหลักที่เตรียมไว้',
  prefabricationOrderSplitting: 'เอกสารย่อยที่เตรียมไว้',
  printMasterOrder: 'พิมพ์เอกสารหลัก',
  printSplit: 'พิมพ์เอกสารย่อย',
  track: 'ติดตาม',
  takeOff: 'ขึ้นบิน',
  arrival: 'ถึงท่า',
  Discharge: 'การขนถ่ายเรือ',
  billOfLadingInquiry: 'สอบถามใบตราส่ง',
  expandAll: 'ขยายทั้งหมด',
  putItAllAway: 'ย่อทั้งหมด',
  noBusinessFlight: 'เที่ยวบินไม่มีธุรกิจ',
  heavy: 'น้ำหนัก',
  takeOff2: 'ขึ้นบินแล้ว',
  arrivedAtPort: 'ถึงท่าแล้ว',
  size: 'ขนาด',
  cabinAllocationStatus: 'สถานะการจัดห้องโดยสาร',
  installationInstructions: 'คำอธิบายการบรรจุ',
  photograph: 'ถ่ายรูป',
  guanFeng: 'ปิดผนึก',
  singleCopy: 'เอกสารร่วม',
  flightInformationEmpty: 'ข้อมูลเที่ยวบินว่างเปล่า',
  lockFlight: 'ล็อคเที่ยวบิน',
  unlockFlight: 'ปลดล็อคเที่ยวบิน',
  cabinAllocationStatusConfirmed: 'ต้องการตั้งค่าสถานะการจัดสรรตู้ของใบรายการเป็นยืนยันแล้วหรือไม่?',
  confirmationSucceeded: 'ยืนยันสำเร็จ!',
  confirmThis: 'ยืนยันที่จะ',
  cabinAllocationStatusUnconfirmed: 'ต้องการตั้งค่าสถานะการจัดสรรตู้ของใบรายการเป็นยังไม่ยืนยันหรือไม่?',
  hair: 'น้ำหนักรวม',
  selectBookedOrder: 'กรุณาเลือกใบรายการที่จะจองตู้!',
  preprint: 'พิมพ์ล่วงหน้า',
  undoPrinting: 'ยกเลิกการพิมพ์',
  temporaryStorage: 'บันทึกชั่วคราว',
  bookingNumber: 'เลขที่การจองตู้',
  bookingTime: 'เวลาการจองตู้',
  descriptionOfBookingResults: 'คำอธิบายผลการจองตู้',
  declared: 'ผ่านการศุลกากรแล้ว',
  enterDeliveryAgent: 'กรุณากรอกตัวแทนส่งมอบ',
  whetherTakePhotos: 'ถ่ายรูปหรือไม่',
  siteRemarks: 'หมายเหตุภาคสนาม',
  otherInstructions: 'คำอธิบายอื่นๆ',
  enterBillOfLadingNumber: 'กรุณากรอกเลขที่ใบตราส่ง',
  takeoffTime: 'เวลาออกเดินทาง',
  deliveryTime: 'เวลาส่งมอบ',
  trackingFlight: 'ติดตามเที่ยวบิน',
  trackingArrival: 'ติดตามถึงท่า',
  trackingDelivery: 'ติดตามการส่งมอบ',
  enterDepartureTime: 'กรุณากรอกเวลาออกเดินทาง',
  enterArrivalTime: 'กรุณากรอกเวลาถึงท่า',
  enterDeliveryTime: 'กรุณากรอกเวลาส่งมอบ',
  receivingOutsideWarehouse: 'รับสินค้า (คลังภายนอก)',
  warehousingTime: 'เวลาเข้าโกดัง:',
  damagedAndDamp: 'มีรอยเสียหาย/ความชื้น',
  photo: 'รูปภาพ',
  selectPhotos: 'เลือกรูปภาพ',
  deletePhotos: 'ลบรูปภาพ',
  selectWarehousingDate: 'กรุณาเลือกวันที่รับเข้า!',
  enterSubLabel: 'ป้อนป้ายย่อย',
  receiptNo: 'เลขที่ใบรับคืน',
  pleaseEnterSubLabel: 'กรุณากรอกป้ายย่อย',
  uploading: 'กำลังอัปโหลด',
  oneFileVolumn2MB: 'มี 1 ไฟล์ที่มีขนาดเกิน 2MB ไม่สามารถอัปโหลดได้',
  failedDeleteFile: 'ลบไฟล์ไม่สำเร็จ!',
  uploadSucceeded: 'อัปโหลดสำเร็จ',
  uploadFailed: 'อัปโหลดไม่สำเร็จ',
  uploadComplete: 'อัปโหลดไม่สำเร็จ',
  notExceed6Lines: 'สูงสุดไม่เกิน 6 บรรทัด!',
  nodeName: 'ชื่อโหนด',
  nodeState: 'สถานะโหนด',
  warningLevel: 'ระดับการเตือน',
  warningAt: 'เวลาเตือน',
  line: 'เส้นทาง',
  airTransportArea: 'พื้นที่ขนส่งทางอากาศ',
  operationalResponsibilities: 'หน้าที่ปฏิบัติการ',
  assignmentOfResponsibilities: 'การจัดสรรหน้าที่',
  roleList: 'รายการบทบาท',
  assignedResponsibilities: 'มีการมอบหมายหน้าที่แล้ว',
  listOfResponsibilities: 'รายการหน้าที่',
  NoVoucherGeneratedReceivable: 'ยังไม่ได้สร้างเอกสารรับ',
  NoVoucherGeneratedPayable: 'ยังไม่ได้สร้างเอกสารจ่าย',
  VoucherGeneratedReceivable: 'สร้างเอกสารรับแล้ว',
  VoucherGeneratedPayable: 'สร้างเอกสารจ่ายแล้ว',
  TenTicketsAtTheSameTime: 'สามารถดูธุรกิจได้สูงสุด 10 รายการพร้อมกัน กรุณาเลือกใหม่',
  DataChangedToReopen: 'ข้อมูลถูกเปลี่ยนแปลงแล้ว กรุณาเปิดใหม่เพื่อแก้ไข',
  JobOpenedAndCannotDelete: 'ธุรกิจนี้ถูกเปิดในแท็บใหม่แล้ว ไม่สามารถลบได้!',
  AreWantToDeleteBusiness: 'กรุณายืนยันว่าจะลบธุรกิจนี้หรือไม่?',
  DoToDeleteTheTicket: 'ต้องการลบใบเสร็จหรือไม่?',
  AreToDeleteTheBusiness: 'ยืนยันที่จะลบธุรกิจที่เลือกไว้หรือไม่?',
  AreToConvertTheItem: 'ยืนยันที่จะแปลงรายการที่เลือกไว้หรือไม่?',
  ConversionSucceeded: 'แปลงสำเร็จ',
  OperationDepartmentCannotBeEmpty: 'ฝ่ายปฏิบัติงานไม่สามารถเว้นว่างได้!',
  OrangeWorkingDaysFromETA: 'สีส้ม: ภายใน 7 วันทำงานก่อนถึง ETA',
  RedWorkingDaysFromETA: 'สีแดง: ภายใน 3 วันทำงานก่อนถึง ETA',
  BatchOfWholeSplicingType: 'แก้ไขประเภทการรวมขนส่งแบบกลุ่ม:',
  UploadedOnlyBeInFormat: 'สามารถอัปโหลดไฟล์รูปแบบ CSV เท่านั้น!',
  ThatSOk: 'แถว',
  NotInPositiveOperation: 'ไม่ใช่สถานะการทำงานปัจจุบัน',
  AreTicketsSubmitted: 'จะส่งใบงานหรือไม่?',
  IsTheTicketPreSubmitted: 'จะส่งใบงานเบื้องต้นหรือไม่?',
  AreWantToWithdrawTicket: 'ยืนยันที่จะถอนธุรกิจนี้หรือไม่?',
  BillOfLadingInformationTracking: 'ติดตามข้อมูลใบตราส่งสินค้า',
  PleaseMaintainTheJumpAddress: 'กรุณาบำรุงรักษาที่อยู่สำหรับเปลี่ยนหน้า!',
  CannotBeEmpty: 'ไม่สามารถเว้นว่างได้',
  AreWantToRemoveTicket: 'ยืนยันที่จะนำใบเสร็จนี้ออกหรือไม่?',
  NoBusinessSelected: 'ยังไม่ได้เลือกธุรกิจ',
  IfForTheGoodsSame: 'หากสินค้านี้ใช้ราคาตามสัญญากับตัวแทนต่างประเทศหรือบริษัทเรือเดียวกัน ให้ติ๊กที่นี่',
  EspeciallyPeersThatUBISpace: 'เฉพาะบริษัทเรือหรือคู่แข่งที่ UBI ไปจองพื้นที่เรือ',
  UnitKg: 'หน่วย: กิโลกรัม',
  UnitCubicMeter: 'หน่วย: ลูกบาศก์เมตร',
  UnitTon: 'หน่วย: ตัน',
  DoorNotBeenSavedPrinted: 'ข้อมูลจุดรับส่งที่ยังไม่ได้บันทึก ไม่สามารถพิมพ์ได้!',
  CaseNo: 'หมายเลขตู้คอนเทนเนอร์คือ',
  AllTheAssociationDoContinue: 'ข้อมูลทั้งหมดจะถูกตัดความสัมพันธ์ ต้องการดำเนินการต่อหรือไม่',
  DetailsSeaborneExportGoodsXls: 'รายละเอียดสินค้าส่งออกทางเรือ.xls',
  FindTheTrailerLocationNow: 'ตรวจสอบตำแหน่งรถลากทันที',
  EstimatedLoadingDate: 'วันที่คาดว่าในการบรรทุก',
  SelectDateAndTime: 'เลือกวันที่และเวลา',
  PrimaryDocNoAlreadyExists: 'หมายเลข Master Bill มีอยู่แล้ว',
  PleaseEnterTheFlightNumber: 'กรุณากรอกหมายเลขเที่ยวบิน',
  PleaseEnterETD: 'กรุณากรอก ETD',
  PleaseEnterAnAction: 'กรุณากรอกการดำเนินการ',
  PleaseEnterTheRoute: 'กรุณากรอกเส้นทาง',
  AreWantToAllocateFlight: 'ยืนยันที่จะจัดสรรเที่ยวบินสำหรับธุรกิจ【{0}】นี้หรือไม่?',
  DeploymentSucceeded: 'จัดสรรสำเร็จ!',
  SuccessfullyPicturesAreYouSave: 'อัปโหลดสำเร็จ: {0} รายการ, ล้มเหลว: {1} รายการ ต้องการบันทึกหรือไม่?',
  TheSelectedRecordMustSame: 'ETD ของระเบียนที่เลือกต้องเหมือนกัน!',
  TheSelectedRecordsMustSame: 'สายการบินของระเบียนที่เลือกต้องเหมือนกัน!',
  PleaseWithTheSameMode: 'กรุณาเลือกธุรกิจที่มีโหมดการทำงานเหมือนกัน',
  SiruiPleaseContactTheTroubleshooting: 'การส่งใบมอบหมายของ Sirui ล้มเหลว กรุณาติดต่อเจ้าหน้าที่เพื่อตรวจสอบ:',
  BusinessTodayIsNotCustoms: 'ไม่อนุญาตให้ยกเลิกธุรกิจที่มีวันออกเดินทางมากกว่าวันนี้',
  G7DataPush: 'การส่งข้อมูล G7',
  DropDown: 'ดึงลง',
  TheBeenAddedToOrder: 'ใบแยกได้ถูกเพิ่มเข้าไปในใบหลักแล้ว!',
  NotBoundYet: 'ยังไม่ได้ผูกมัด!',
  TheCostSharingAndSeparated: 'ตั๋วย่อยปัจจุบันมีค่าบริการที่แบ่งปันกัน ไม่สามารถแยกได้!',
  AreUnbindTheMasterOrder: 'แน่ใจหรือไม่ที่จะยกเลิกการผูกมัดกับตั๋วหลักหรือใบหลัก?',
  PleaseEnterOperatorInformation: 'กรุณากรอกข้อมูลผู้ปฏิบัติงาน!',
  TheIsIllegalPleaseEnter: 'หมายเลขใบหลักไม่ถูกต้อง กรุณากรอกใหม่!',
  PleaseTheDesignatedShippingAgent: 'กรุณากรอกตัวแทนขนส่งสินค้าที่กำหนด!',
  TheseWillBeSetJoin: 'ฟิลด์เหล่านี้แตกต่างจากตั๋วหลัก หากต้องการเพิ่มเข้าไปจะถูกตั้งค่าให้เหมือนกับตั๋วหลัก ยืนยันที่จะเพิ่มหรือไม่?',
  TheNotExceed6Lines: 'สูงสุดไม่เกิน 6 แถว!',
  TheNotExceed7Lines: 'สูงสุดไม่เกิน 7 แถว!',
  ThereMasterTicketThisPerformed: 'มีค่าใช้จ่ายในตั๋วหลัก ไม่สามารถดำเนินการนี้ได้!',
  TheTicketIfYouSwitch: 'ตั๋วย่อยถูกผูกมัดกับตั๋วหลักและมีเพียงตั๋วย่อยเดียวภายใต้ตั๋วหลัก หากเปลี่ยนโหมดการทำงานตั๋วหลักจะถูกลบ! ยืนยันที่จะเปลี่ยนหรือไม่?',
  TheTheBindingRelationshipSwitch: 'ตั๋วย่อยถูกผูกมัดกับตั๋วหลัก หากเปลี่ยนโหมดการทำงานจะยกเลิกการผูกมัดกับตั๋วหลัก! ยืนยันที่จะเปลี่ยนหรือไม่?',
  SwitchAMasterTicketSwitch: 'เปลี่ยนเป็นโหมดการทำงานหนึ่งหลักหลายย่อย ระบบจะสร้างตั๋วหลักและผูกมัดกับตั๋วปัจจุบันโดยอัตโนมัติ! ยืนยันที่จะเปลี่ยนหรือไม่?',
  DateExceededCreditControl: 'คู่ค้าเกินกำหนดชำระเงินแล้ว!',
  AmountExceededCreditControl: 'คู่ค้าเกินวงเงินแล้ว!',
  DateAndAmountExceededCreditControl: 'คู่ค้าเกินทั้งวงเงินและกำหนดชำระเงินแล้ว!',
  ThisHasExceededCreditControl: 'คู่ค้านี้เกินการควบคุมเครดิตแล้ว',
  ItAEntrustingUnitAgent: 'ไม่สามารถใช้เป็นหน่วยมอบหมายหรือตัวแทนขนส่งสินค้าที่กำหนดได้',
  ThisHasBeenAutomaticallyCleared: 'ได้ล้างคอลัมน์นี้โดยอัตโนมัติแล้ว',
  JoinTheTicketSuccessfully: 'เพิ่มตั๋วย่อยสำเร็จ!',
  ThereSplitTicketTheTicket: 'ตั๋วหลักปัจจุบันมีเพียงตั๋วย่อยเดียว หากนำตั๋วย่อยออก ตั๋วหลักจะถูกลบโดยอัตโนมัติ ยืนยันที่จะนำตั๋วย่อยออกหรือไม่?',
  TheTicketHasBeenRemoved: 'ตั๋วหลักถูกนำออกแล้ว!',
  AreRemoveThisSubTicket: 'แน่ใจหรือไม่ที่จะนำตั๋วย่อยนี้ออกจากตั๋วหลัก?',
  AttachmentDescription: 'คำอธิบายไฟล์แนบ',
  AirlineCachePleaseResetAgain: 'ไม่พบข้อมูลสายการบินในแคช กรุณารีเซ็ตแคชและลองอีกครั้ง',
  ResettingTheModifiedContentContinue: 'การรีเซ็ตค่าตั้งต้นจะทับเนื้อหาที่แก้ไขแล้ว ต้องการดำเนินการต่อหรือไม่?',
  PleaseEnterTheSplitNumber: 'กรุณากรอกหมายเลขใบแยก',
  AlreadyExists: 'มีอยู่แล้ว!',
  DetailsAirExportGoodsXls: 'รายละเอียดสินค้าส่งออกทางอากาศ.xls',
  PleaseSelectWarehousingData: 'กรุณาเลือกข้อมูลการนำสินค้าเข้า!',
  AreToDeleteThisData: 'แน่ใจหรือไม่ที่จะลบข้อมูลการนำสินค้าเข้านี้?',
  TheRateMAndAdjusted: 'ค่า TOTAL น้อยกว่าค่าโดยสาร M ที่บำรุงรักษาไว้ ไม่สามารถปรับข้อมูลที่เกี่ยวข้องกับค่าโดยสารได้!',
  AirlineInformation: 'ข้อมูลสายการบิน',
  PleaseSelectAFee: 'กรุณาเลือกค่าใช้จ่ายหนึ่งรายการ',
  SelectMainOrder: 'เลือกใบหลัก',
  ManualInput: 'ป้อนด้วยตนเอง:',
  TheOrderNumberIsIllegal: 'หมายเลขใบหลักไม่ถูกต้อง!',
  WarehousingInstructions: 'คำอธิบายการนำสินค้าเข้า',
  OtherInstructions: 'คำอธิบายอื่นๆ:',
  GoodsIntoThisWarehouse: 'สินค้าเข้าคลังนี้',
  NeedPhotos: 'ต้องการรูปภาพ',
  AttachedDocuments: 'เอกสารแนบแบบสุ่ม',
  Generate: 'สร้าง',
  Save: 'ต้องการบันทึกหรือไม่?',
  PleaseTheEstimatedWarehousingTime: 'กรุณากรอกเวลาที่คาดว่าจะเข้าคลัง!',
  AirlineCompany: 'สายการบิน:',
  Flight: 'เที่ยวบิน:',
  FieldOperation: 'ปฏิบัติงานหน้างาน:',
  SendFieldOperation: 'ส่งการปฏิบัติงานหน้างาน',
  EntrustedWeight: 'น้ำหนักที่มอบหมาย',
  NumberOfBookingPieces: 'จำนวนการจองพื้นที่',
  BookingWeight: 'น้ำหนักการจองพื้นที่',
  BookingVolume: 'ปริมาตรการจองพื้นที่',
  PleaseFillInTheFlight: 'กรุณากรอกเที่ยวบิน!',
  PromissoryHaveBecomeOfficialBusiness: 'รายการนี้เป็นธุรกรรมอย่างเป็นทางการแล้ว',
  ThisApprovalStatusAndEdited: 'รายการนี้อยู่ในสถานะการอนุมัติทางการเงินแล้ว ไม่สามารถแก้ไขได้',
  AreToConvertTheItem2: 'แน่ใจหรือไม่ที่จะแปลงรายการที่เลือกไว้?',
  TheDoesNotComplyRules: 'หมายเลข Master ไม่ตรงตามกฎ!',
  DoubleOfLadingHeaderUp: 'ดับเบิลคลิกที่หัวบิลเพื่อเปิด',
  SmallNumberOfVotes: 'จำนวนรายการย่อย',
  NumberOfPrimaryVotes: 'จำนวนรายการหลัก',
  ThePleaseMaintainTheFirst: 'หมายเลข Master ว่างเปล่า กรุณากรอกหมายเลข Master ก่อน',
  TheTheNewlySelectedContinue: 'หมายเลขเที่ยวบิน สายการบิน วันที่ออกบิน วันที่ถึงท่า วิธีการปล่อยสินค้าและเงื่อนไขค่าขนส่งของ Master Bill ที่เลือกใหม่ไม่ตรงกับ Master Bill ระบบจะแก้ไข House Bill ต้องการดำเนินการต่อหรือไม่?',
  ClickSelectTheGoodsCode: 'กด Space เพื่อเลือกรหัสประเภทสินค้า',
  AreSureVoidThisTicket: 'แน่ใจหรือไม่ที่จะยกเลิกธุรกรรมนี้?',
  AllChargesBeDeleted: 'ค่าบริการทั้งหมดจะถูกลบ!',
  SellingPriceCalculationCompleted: 'คำนวณราคาขายเสร็จสิ้น',
  OperationOfTicketCannotEdited: 'คุณไม่ใช่ผู้ดำเนินการรายการนี้ จึงไม่สามารถแก้ไขได้',
  ActualNotifierCannotBeBlank: 'ผู้แจ้งจริงไม่สามารถเว้นว่างได้',
  SpecifiedFreightAgentCannotEmpty: 'ตัวแทนขนส่งที่กำหนดไม่สามารถเว้นว่างได้',
  ArrivalDateCannotBlank: 'วันที่ถึงท่าไม่สามารถเว้นว่างได้',
  OperationDepartmentCannotBlank: 'แผนกปฏิบัติงานไม่สามารถเว้นว่างได้',
  ExpectedArrivalDateCannotBlank: 'วันที่คาดว่าจะถึงท่าไม่สามารถเว้นว่างได้',
  PleaseReselect: 'กรุณาเลือกใหม่',
  EstimatedProfitNotCompanyRegulations: 'กำไรโดยประมาณของธุรกรรมนี้ไม่อยู่ในเกณฑ์ที่บริษัทกำหนด {0} ต้องการยืนยันการบันทึกหรือไม่?',
  ReceivableExpensesMustBeEntered: 'ต้องกรอกค่าบริการที่ต้องรับ',
  PayableExpensesMustBeEntered: 'ต้องกรอกค่าบริการที่ต้องจ่าย',
  BlockedCannotUsedContactCustomerManagement: '[{0}] ถูกบล็อกแล้ว ไม่สามารถใช้งานได้ กรุณาติดต่อเจ้าหน้าที่ดูแลลูกค้าของบริษัท',
  CompanyBlockedCannotUsedWithReason: '[{0}] ถูกบล็อก เหตุผลการระงับ: [{1}]',
  CompanyBlockedCannotUsed: '[{0}] ถูกบล็อก',
  exportOption: 'ตัวเลือกการส่งออก',
  exportDescription: 'คำอธิบายการส่งออก',
  dataNotMerged: 'ไม่รวมข้อมูล',
  noMoreReminders: 'ไม่เตือนอีก',
  UsCustomsClearance: 'ศุลกากรสหรัฐ',
  CustomerInformation: 'ข้อมูลลูกค้า',
  DeclarationMaterials: 'ข้อมูลการประกาศ',
  TopSecretInformation: 'ข้อมูลลับสุดยอด',
  DeletionIsUnrecoverable: 'การลบไม่สามารถกู้คืนได้ กรุณายืนยันการลบข้อมูล?',
  PleaseEnterOnLine: 'กรุณากรอก {1} ของแถวที่ {0}',
  CustomerName: 'ชื่อสินค้าของลูกค้า',
  CustomsClearanceProductName: 'ชื่อสินค้าศุลกากร',
  NumberOfPackages: 'จำนวนบรรจุภัณฑ์',
  NumberOfGoods: 'จำนวนชิ้นสินค้า',
  CustomsClearanceUnit: 'หน่วยศุลกากร',
  Export7501: 'ส่งออกแบบฟอร์ม 7501',
  ExportInvoicePackingList: 'ส่งออกใบแจ้งหนี้และรายการบรรจุภัณฑ์',
  GenerateReceivableExpense: 'สร้างค่าบริการที่ต้องรับ',
  GeneratePayableExpenses: 'สร้างค่าบริการที่ต้องจ่าย',
  CopyAsCustomerData: 'คัดลอกเป็นข้อมูลลูกค้า',
  CopyAsDeclarationData: 'คัดลอกเป็นข้อมูลการประกาศ',
  CopyAsTopSecretInformation: 'คัดลอกเป็นข้อมูลลับสุดยอด',
  PdfType: 'ประเภท PDF',
  MergeProductNamesWhenFiles: 'รวมชื่อสินค้าที่เหมือนกันเมื่อสร้างไฟล์',
  ShowTax: 'แสดงภาษี',
  ShowChinaSurtax: 'แสดงภาษีเพิ่มเติมของจีน',
  ShowMargin: 'แสดงเงินประกัน',
  MarginAmount: 'จำนวนเงินประกัน',
  TotalNetWeight: 'น้ำหนักสุทธิรวม',
  TotalValue: 'มูลค่าสินค้ารวม',
  TotalTariff: 'รวมภาษีศุลกากร',
  TotalOtherExpenses: 'รวมค่าบริการอื่นๆ',
  UnitWeight: 'น้ำหนักสินค้าต่อชิ้น',
  ItemPricing: 'ราคาสินค้าต่อหน่วย',
  TotalPriceOfGoods: 'ราคาสินค้ารวม',
  ChinaAdditionalTaxRate: 'อัตราภาษีเพิ่มเติมของจีน',
  ChinasSurtaxTariff: 'กฎหมายภาษีเพิ่มเติมของจีน',
  ChinaSurtaxClause: 'ข้อกำหนดภาษีเพิ่มเติมของจีน',
  AccountsReceivableGeneratedSuccessfully: 'สร้างค่าบริการที่ต้องรับสำเร็จ',
  PayableExpensesGeneratedSuccessfully: 'สร้างค่าบริการที่ต้องจ่ายสำเร็จ',
  ThePleaseConfirmWhetherData: 'การล้างข้อมูลไม่สามารถกู้คืนได้ โปรดยืนยันว่าต้องการล้างข้อมูลหรือไม่?',
  TheSureYouWantData: 'การลบไม่สามารถกู้คืนได้ โปรดยืนยันว่าต้องการลบข้อมูลแถวนี้หรือไม่?',
  BusinessDateChangedUpdateExchangeRate: 'วันที่ทำธุรกิจมีการเปลี่ยนแปลง โปรดอัปเดตอัตราแลกเปลี่ยนค่าบริการ',
  CustomsClearance: 'ผ่านศุลกากร',
  QuantityIsInconsistentOfEqSizeType: '【{eqSize}{eqType}】จำนวนตู้คอนเทนเนอร์กับข้อมูลการบรรจุไม่ตรงกัน',
  QuantityIsInconsistentOfCodeType: '【{containerCode}{containerType}】จำนวนตู้กับข้อมูลการบรรจุแผ่นไม่ตรงกัน',
  syncChargesToExportJobMessage: 'ซิงค์ข้อมูลทั้งหมด {total} รายการ สำเร็จ {successCount} รายการ ล้มเหลว {failCount} รายการ',
  syncChargesToExportJobFailMessage: '<span>ซิงค์ <span style="color:blue">{total}</span>ค่าแถบ</span>สำเร็จ<span style="color:green">{successCount}</span>ชิ้นล้มเหลว<span style="color:red">{failCount}</span>ชิ้น</span> <br />\n' +
    '<b>เหตุผลดังต่อไปนี้</b><br />',
  ImportReceivablePpayableObjectNotEqualCustomer: 'ค่าบริการ {no}: หน่วยชำระค่าบริการนำเข้า/ค่าบริการที่ต้องจ่าย != ผู้ส่งออก (หน่วยมอบหมาย)',
  BillGenerated: 'ค่าบริการ {no}: ได้สร้างใบแจ้งหนี้แล้ว',
  InvoiceIssued: 'ค่าบริการ {no}: ได้ออกใบแจ้งหนี้แล้ว',
  AccountWrittenOff: 'ค่าบริการ {no}: ได้ทำการตัดจ่ายแล้ว',
  PaymentApplication: 'ค่าบริการ {no}: ได้ยื่นคำขอชำระเงินแล้ว',
  ExpenseConfirmationYes: 'ค่าบริการ {no}: ยืนยันค่าบริการ - ใช่',
  ExpenseStatusSubmitted: 'ค่าบริการ {no}: สถานะค่าบริการ - ได้ส่งแล้ว',
  CollectionAdvancePayment: 'ค่าบริการ {no}: ได้รับการชำระล่วงหน้าแทนแล้ว',
  ExpensesGeneratedByVarianceProcessing: 'ค่าบริการ {no}: เป็นค่าบริการที่เกิดจากการจัดการส่วนต่าง',
  Shared: 'ค่าบริการ {no}: ได้แบ่งสรรแล้ว',
  NotOperatingCannotSynchronized: 'คำสั่งซื้อที่ไม่ถูกต้องไม่สามารถดำเนินการซิงค์ได้',
  ImportHasSynchronizedDispatchingInformation: '<b style="font-size:16px">คำสั่งซื้อนำเข้าได้vข้อมูลการจัดรถแล้ว</b><br><span style="font-size:16px">คุณต้องการดำเนินการต่อหรือไม่?</span>',
  MatchingConditionsForPushSOPReceiver: 'เงื่อนไขการจับคู่ผู้รับ SOP ที่ผลักดัน',
  GenerateXChargeSyncRecords: 'สร้างบันทึกการvค่าบริการ {num} รายการ',
  Density: 'ความหนาแน่น',
  CommissionedDensity: 'ความหนาแน่นของมอบหมาย',
  ActualDensity: 'ความหนาแน่นจริง',
  EstimatedReviewer: 'ผู้ตรวจสอบล่วงหน้า',
  DateOfPreReview: 'วันที่ตรวจสอบล่วงหน้า',
  EnteredXNotMatchAirlineCode: 'รหัสเที่ยวบินที่ป้อน {0} ไม่ตรงกับรหัสสายการบิน Airline Code',
  EnteredXNotMatchAirlinePrefix: 'สามตัวแรกของหมายเลขใบตราส่งหลัก {0} ไม่ตรงกับคำนำหน้า MAWB ของสายการบิน',
  HasPackingFeeEnterWarehouse: 'มีค่าบรรจุภัณฑ์ กรุณากรอกข้อมูลคลังสินค้า!',
  SuccessSyncInfo: 'ซิงค์ข้อมูลสำเร็จ',
  Search: 'ค้นหา',
  Clear: 'ล้าง',
  ShipperName: 'ชื่อผู้ส่ง',
  ConsigneeName: 'ชื่อผู้รับ',
  NotifyPartyName: 'ชื่อผู้แจ้ง',
  AfterToBeRevokedSynchronize: 'ยืนยันการซิงค์แล้วจะไม่สามารถยกเลิกได้ ยืนยันที่จะซิงค์หรือไม่?',
  PleaseADataToDelete: 'กรุณาเลือกข้อมูลหนึ่งรายการเพื่อลบ!',
  CreatePaymentRequestSelectFee: 'สร้างคำขอชำระเงิน-เลือกค่าใช้จ่าย',
  PleaseSelectTheBill: 'กรุณาเลือกบิล.',
  YouViewOrPrintOthers: 'คุณไม่มีสิทธิ์ดูไฟล์ที่อัปโหลดหรือพิมพ์โดยผู้อื่น.',
  AgentCommissionBill: 'บิลแบ่งส่วนตัวแทน',
  TheWithdrawnAndCannotOperated: 'ธุรกิจถูกถอนแล้ว ไม่สามารถดำเนินการได้',
  PleaseSelectTheForeignBill: 'กรุณาเลือกบิลต่างประเทศ.',
  Equivalent: 'เทียบเท่า',
  EquivalentToRMB: 'เทียบเท่า RMB',
  OperationFailed: 'การดำเนินการล้มเหลว',
  FrontEndErrorCallbackFailed: 'ข้อผิดพลาดส่วนหน้า: การเรียกกลับล้มเหลว',
  YouToEditTheAdministrator: 'คุณไม่มีสิทธิ์ในการแก้ไขข้อมูล กรุณาติดต่อผู้ดูแลระบบ',
  UploadingPleaseWait: 'กำลังอัปโหลด กรุณารอสักครู่......',
  AssociateBusinessSOPNode: 'โหนด SOP ธุรกิจที่เกี่ยวข้อง',
  CustomsDuty: 'ภาษีศุลกากร',
  AddAmendmentFee: 'เพิ่มค่าใช้จ่ายในการแก้ไขใบสั่ง',
  AddNewBusiness: 'เพิ่มธุรกิจ',
  Add: 'เพิ่ม',
  Maintain: 'รักษา',
  Modify: 'แก้ไข',
  PleaseEnterTheBusinessNumber: 'กรุณากรอกรหัสธุรกิจ!',
  ReceiptSuccessful: 'ได้รับใบเสร็จสำเร็จ',
  WaitingForReceipt: 'รอใบเสร็จ',
  SaveSuccessfully: 'บันทึกสำเร็จ',
  SendEmail: 'ส่งอีเมล',
  SystemEmail: 'อีเมลระบบ',
  CompanyEmail: 'อีเมลบริษัท',
  PersonalEmail: 'อีเมลส่วนตัว',
  Submitted: 'ส่งแล้ว',
  DataSource: 'แหล่งที่มาของข้อมูล',
  SystemInput: 'ป้อนข้อมูลระบบ',
  PortAreaData: 'ข้อมูลท่าเรือ',
  UpdateToPortAreaData: 'อัปเดตเป็นข้อมูลท่าเรือ',
  NewExportClearancePolicy: 'กฎใหม่การปล่อยสินค้าออก',
  YangshanAreaNovember152021: 'เขตศุลกากรหยางซาน: 15 พฤศจิกายน 2021',
  WaigaoqiaoAreaNovember222021: 'เขตศุลกากรท่าเรือนอก: 22 พฤศจิกายน 2021',
  GarbageManifest: 'ใบรายการสินค้าเสีย (Garbage Manifest)',
  N1OnceTheManifestManifest: '1.ศุลกากรห้ามใช้ใบรายการสินค้าเสียอย่างเด็ดขาด! ตามกฎหมายศุลกากร ทุกใบรายการสินค้าที่เตรียมไว้ล่วงหน้า (Pre-Manifest) ต้องสอดคล้องกับสินค้าที่ส่งออกจริง เมื่อส่งใบรายการสินค้าแล้ว หากสินค้าของคุณไม่ได้ส่งออก (เช่น ไม่ทันเรือ, แผนการส่งออกเปลี่ยนแปลง ฯลฯ) ใบรายการสินค้านั้นจะถือเป็นใบรายการสินค้าเสีย!',
  N2ManifestMustBeDeletion: '2.ตัวอย่างกรณีใบรายการสินค้าเสีย: หลังจากเปลี่ยนเรือแล้ว ต้องลบใบรายการสินค้าที่เตรียมไว้เดิมก่อน จึงจะสามารถส่งใบรายการสินค้าใหม่ได้!',
  N3YuanOnTheManifest: '3. ผลที่ตามมาของการไม่ได้ลบรายการขยะ: ไม่เพียง แต่จะส่งผลกระทบต่อการโหลดศุลกากรสูงสุดยังสามารถปรับ 50,000 หยวนสำหรับผู้ส่งและตัดสิทธิ์การประกาศศุลกากร! หลังจากรายการถังขยะปรากฏขึ้นโปรดติดต่อฝ่ายบริการลูกค้าเพื่อช่วยในการลบรายการถังขยะ!',
  BusinessUUIDCannotBeEmpty: 'UUID ธุรกรรมไม่สามารถเว้นว่างได้!',
  BillUUIDCannotBeEmpty: 'UUID ใบแจ้งหนี้ไม่สามารถเว้นว่างได้!',
  FileInformation: 'ข้อมูลเอกสาร',
  BillingInformation: 'ข้อมูลใบแจ้งหนี้',
  DomesticWarehouse: 'คลังสินค้าในประเทศ',
  ForeignWarehouse: 'คลังสินค้าต่างประเทศ',
  ExpectedTimeAtAmazonWarehouse: 'เวลาที่คาดว่าจะเข้าคลัง Amazon',
  ReferenceBoxNumber: 'หมายเลขกล่องอ้างอิง',
  TotalDoesNotEqualCost: 'ยอดรวมค่าใช้จ่ายที่แบ่งตามใบเสร็จไม่เท่ากับค่าใช้จ่ายเดิม!',
  NameCannotBeEmpty: 'ชื่อไม่สามารถเว้นว่างได้!',
  SOPOperationStatus: 'สถานะการดำเนินการ SOP',
  AddSpecialFees: 'เพิ่มค่าใช้จ่ายพิเศษ',
  TrailerTrackingUsageNotice: 'หนังสือแจ้งการใช้บริการติดตามรถลาก',
  N1SituationIncludingButDepartments: '1.ตามกฎหมายที่เกี่ยวข้องของประเทศ ระบบมีหน้าที่บันทึกประวัติการสืบค้นของผู้ใช้ ซึ่งรวมถึงแต่ไม่จำกัดเพียง (ป้ายทะเบียนรถที่สืบค้น, ผู้ดำเนินการสืบค้น, เวลาที่สืบค้น) เพื่อเป็นหลักฐานเมื่อหน่วยงานที่เกี่ยวข้องร้องขอ',
  N2ConsentBeforeQueryingCommunication: '2.ตามกฎหมายที่เกี่ยวข้องของประเทศ ก่อนสืบค้นตำแหน่งรถ โปรดได้รับความยินยอมจากเจ้าของรถก่อน ผู้ใช้ควรตกลงกับเจ้าของรถล่วงหน้าเพื่อป้องกันการละเมิดสิทธิ',
  N3TheOwnersConsentConsequences: '3.หากผู้ใช้สืบค้นข้อมูลรถโดยไม่ได้รับความยินยอมจากเจ้าของรถ ผู้ใช้จะต้องรับผิดชอบทางกฎหมายด้วยตนเอง',
  N4ItToIrrelevantUser: '4.แม้ผู้ใช้จะได้รับอนุญาตจากเจ้าของรถแล้ว ก็โปรดใช้ข้อมูลภายในขอบเขตที่ได้รับอนุญาต ห้ามใช้เกินขอบเขตหรือเปิดเผยให้บุคคลที่สามที่ไม่เกี่ยวข้อง มิฉะนั้นผู้ใช้จะต้องรับผิดชอบทางกฎหมายด้วยตนเอง',
  N5SystemCannotGuaranteeResponsibility: '5.เนื่องจากปัจจัยภายนอกที่ควบคุมไม่ได้ (เช่น อุปกรณ์ GPS ขัดข้อง) ระบบไม่สามารถรับรองความถูกต้องของผลการสืบค้น ผู้ใช้ต้องเข้าใจและยอมรับว่าระบบไม่รับผิดชอบต่อความถูกต้องของผลลัพธ์',
  N6BeAwareOfHome: '6.เนื่องจากปัจจุบันบริการติดตามรถลากเป็นการร่วมมือกับบุคคลที่สาม (Duckbill) การใช้บริการถือว่าผู้ใช้ยินยอมให้บุคคลที่สามทราบถึงการมีอยู่ของท่านและอาจติดต่อท่าน ซึ่งไม่ใช่การรั่วไหลของข้อมูลจาก CargoWare/บ้านว้าเหลียน',
  DoNotRemindMeAgain: 'ไม่เตือนอีกในครั้งต่อไป',
  IUnderstoodAndConfirmContinuing: 'ทราบแล้ว ยืนยันดำเนินการต่อ',
  ImportModeTip: 'ประเภทการนำเข้าเป็นการแก้ไข ระบบจะจับคู่ข้อมูลกับท่าเรือตามหมายเลขใบผ่านศุลกากร หมายเลขตู้ หมายเลขซีล ประเภทตู้ และชนิดตู้\nประเภทการนำเข้าเป็นการคงไว้ หมายถึงข้อมูลที่ป้อนเข้าไม่พบการจับคู่กับข้อมูลท่าเรือ จึงคงเป็นข้อมูลเดิมที่ป้อนเข้า',
  NewExportClearancePolicyTip: 'คำสั่งของศุลกากรเซี่ยงไฮ้ 172 เปลี่ยนเงื่อนไขการปล่อยการส่งข้อมูลการปล่อยทะเลไปยังท่าเทียบเรือพร้อมกับ "รายการสินค้าโหลด" โปรดติดตามสถานะของรายการโหลดด้วยตนเองหลังจากประกาศศุลกากรเสร็จสิ้น ความผิดปกติติดต่อฝ่ายบริการลูกค้าเพื่อยืนยันทันที เมื่อถึงเวลานั้นรายการซ้ำซ้อนใน LCL ไม่ถูกลบออกในเวลาตกสินค้าไม่ทันเวลาการประกอบที่ไม่ได้มาตรฐานหลังจากการปล่อยการปรับเปลี่ยนข้อมูลรายการสินค้าไม่ประสบความสำเร็จการผสมและการใช้ซ้ำของหมายเลข B / L ภายในสองปีจะมีผลต่อการโหลด ประการที่สอง หลังจากรายการโหลดได้รับการตอบกลับตามปกติแล้ว หากพบสถานการณ์ใด ๆ ที่รายการโหลดล่วงหน้าจําเป็นต้องแก้ไข ลบหรือเพิ่มรายการใหม่ คุณต้องติดต่อตัวแทนเรือเพื่อลบรายการโหลดก่อนแล้วจึงดําเนินการต่อไป',
  Upload0UploadFailed0: 'อัปโหลดสำเร็จ: {0} รายการ, อัปโหลดล้มเหลว: {1} รายการ',
  CustomerBranchScopeNot: '【หน่วยงานผู้ว่าจ้าง】สาขาที่การเป็นเจ้าของไม่ถูกต้อง โปรดเลือกใหม่ให้สอดคล้องกัน',
  BatchInitiateCollaboration: 'เริ่มการทำงานร่วมกันเป็นชุด',
  OrderCenterBranchNotAvailable: '{0} เป็นสาขารับงาน แต่ยังไม่ได้เปิดการตั้งค่าสาขารับงาน',
  BatchCollaboration: 'ทำงานร่วมกันเป็นชุด',
  SuccessCooperateX: 'ทำงานร่วมกันสำเร็จ {0} ธุรกรรม',
  SuccessCooperateXFailY: 'ทำงานร่วมกันสำเร็จ {0} ธุรกรรม, ล้มเหลว {1} ธุรกรรม สาเหตุที่ล้มเหลว:',
  BusinessIsMaster: 'ธุรกรรม {0} เป็นตั๋วหลัก',
  NotBranchCollaborationManageme: 'ธุรกรรม {0} ไม่ใช่สาขารับงาน และไม่มีสิทธิ์จัดการการทำงานร่วมกันของบริษัท',
  OpOfficeNotCooperateBranch: 'บริษัทดำเนินการธุรกรรม {0} ไม่สามารถเป็นสาขาที่ทำงานร่วมกันได้',
  ExistCollaborationBranchRecord: 'ธุรกรรม {0} มีบันทึกการทำงานร่วมกันกับสาขา {1} อยู่แล้ว',
  EntrustedRecipient: 'ผู้รับมอบหมาย',
  NoteConsigneeCustomerExportImport: 'หมายเหตุ: เมื่อส่งออก "ผู้รับ" สอดคล้องกับการนำเข้า "หน่วยหลัก" โปรดตรวจสอบให้แน่ใจว่าคู่ค้านี้มีบทบาท "ลูกค้า" อยู่!!',
  SetAsDefaultExportInfo: 'ตั้งค่าข้อมูลในครั้งนี้เป็นข้อมูลส่งออกเริ่มต้น',
  RecipientNotExist: 'ไม่มีผู้รับสินค้าปัจจุบัน',
  ConsigneeCustomerNotExist: 'ผู้รับปัจจุบันไม่มีบทบาท "ลูกค้า" และไม่สามารถใช้เป็นหน่วยงานหลักโปรดไปที่โมดูลพันธมิตรเพื่อรักษาข้อมูลก่อนที่จะลองอีกครั้ง',
  CurrencyChangeCheckDiff: 'ปรับฟิลด์สกุลเงินเป็น: {0} โปรดระวังจำนวนทศนิยมของสกุลเงินที่เกี่ยวข้องเช่น 【Prepaid】【Collect】และ【Other Charge】',
  InvalidBillCannotConfirm: 'ไม่สามารถยืนยันใบแจ้งหนี้ที่ถูกยกเลิกได้ โปรดตรวจสอบ',
  Reviewed: 'ตรวจสอบแล้ว',
  ApplicationPayInitiated: 'ได้เริ่มการขอชำระเงินแล้ว',
  NotPrintedState: 'ไม่ใช่สถานะที่พิมพ์แล้ว',
  StatementGenerated: 'สร้างใบแจ้งยอดแล้ว',
  NotUnapproved: 'ไม่ใช่สถานะที่ยังไม่ได้รับการอนุมัติ',
  BillCannotVoid: '{0}บิล{1}ไม่สามารถยกเลิกได้ โปรดยืนยัน',
  SwitchHQNotView: 'คุณได้เปลี่ยนไปที่สาขา HQ ซึ่งไม่มีสิทธิ์ดูหน้ารายละเอียด กรุณากลับไปที่หน้ารายการเพื่อค้นหาใหม่',
  JumpListPage: 'ไปที่หน้ารายการ',
  WhenDepartmentBranchNewSelection: 'เมื่อแผนกหรือสาขาของพนักงานฝ่ายขาย/เอกสาร/บริการลูกค้าไม่ตรงกับเอกสารเดิม จำเป็นต้องเลือกใหม่!',
  OneClickQuery: 'ค้นหาด้วยคลิกเดียว',
  PreSubimtCheckTip: 'หมายเหตุ: หลังจากส่งคำขอเบื้องต้นแล้วจะไม่สามารถแก้ไขได้ เมื่อส่งคำสั่งซื้อทั้งหมดเสร็จสิ้น สามารถใช้ปุ่ม "ค้นหาด้วยคลิกเดียว" ด้านล่างเพื่อค้นหาคำสั่งซื้อที่ล้มเหลว',
  SubimtCheckTip: 'หมายเหตุ: หลังจากส่งคำขอแล้วจะไม่สามารถแก้ไขได้ เมื่อส่งคำสั่งซื้อทั้งหมดเสร็จสิ้น สามารถใช้ปุ่ม "ค้นหาด้วยคลิกเดียว" ด้านล่างเพื่อค้นหาคำสั่งซื้อที่ล้มเหลว',
  FinanceAuditCheckTip: 'หมายเหตุ: หลังจากอนุมัติแล้วจะไม่สามารถแก้ไขได้ เมื่ออนุมัติคำสั่งซื้อทั้งหมดเสร็จสิ้น สามารถใช้ปุ่ม "ค้นหาด้วยคลิกเดียว" ด้านล่างเพื่อค้นหาคำสั่งซื้อที่ล้มเหลว',
  SalesMapping: 'การแมปฝ่ายขาย:',
  SalesCargoSalesMap: 'การแมปฝ่ายขายของงานที่มอบหมายไปยังฝ่ายขายที่รับงานปฏิบัติการ',
  BusinessRemarks: 'หมายเหตุงาน',
  InternalEquipmentNote: 'หมายเหตุภายใน',
  QuantityWeightCubageConfirmed: 'ยืนยันจำนวนน้ำหนักและปริมาณแล้ว',
  DataModifiedHasMergeContinueSave: 'ข้อมูลถูก[{0}]แก้ไขเมื่อ {1} ระบบได้รวมข้อมูลให้คุณแล้ว ต้องการบันทึกหรือไม่?',
  SyncYongYouNotCancelReview: 'เคยส่งไปยังระบบ Yonyou แล้ว ไม่สามารถยกเลิกการอนุมัติได้',
  PrintByBusinessNumber: 'พิมพ์ตามหมายเลขงาน',
  SelectNotBelongToCurBranch: 'เอกสารที่เลือกมีเอกสารงานที่ไม่ใช่ของสาขาปัจจุบัน ไม่สามารถแก้ไขได้!',
  ClickFilePrivew: 'คลิกที่ชื่อไฟล์เพื่อดูตัวอย่าง',
  PackageDownload: 'ดาวน์โหลดแบบรวม',
  CCPost: 'ส่งสำเนาถึงตำแหน่ง',
  CCYourself: 'ส่งสำเนาให้ตัวเอง',
  SaveCcAddresNextDefault: 'บันทึกตำแหน่งที่ส่งสำเนาครั้งนี้ (เพื่อใช้เป็นค่าเริ่มต้นในครั้งต่อไป)',
  ForMakingBatchTransferModifications: 'หมายเลขงาน {0} เลือกเฉพาะข้อมูลรายย่อย ไม่ได้เลือกข้อมูลหลัก จึงไม่สามารถเปลี่ยนเรือแบบกลุ่มได้ กรุณาเลือกข้อมูลหลักที่เกี่ยวข้องเพื่อแก้ไข',
  TherePositionPleaseConfirmSuitable: 'ตำแหน่ง <b>{0}</b> มีหลายตัวเลือก กรุณายืนยันว่าผู้ที่เลือกในปัจจุบันเหมาะสม',
  TheWithBusinessStandardsSelection: 'ตำแหน่ง <b>{0}</b> ไม่ตรงตามมาตรฐานงาน กรุณาเลือกใหม่',
  PositionReSelectionReminder: 'แจ้งเตือนการเลือกตำแหน่งใหม่',
  LastEmailSentTime: 'เวลาส่งอีเมลล่าสุด',
  FeeReceivable: 'ค่าใช้จ่าย (ลูกหนี้)',
  CostsPayable: 'ค่าใช้จ่าย (เจ้าหนี้)',
  ListOfHazardousMaterials: 'รายการสินค้าอันตราย',
  DangerousGoodsInformation: 'ข้อมูลสินค้าอันตราย',
  CustomsProcedures: 'ขั้นตอนการผ่านพิธีการศุลกากร',
  CarDispatchInformation: 'ข้อมูลการจัดสรรรถ',
  QuantityGrossWeightVolume: 'จำนวน/น้ำหนักสุทธิ/ปริมาตร',
  CustomFormBusinessBooking: 'แบบฟอร์มที่กำหนดเอง (การจองธุรกิจ)',
  BusinessOperationInstruction: '[คำสั่งดำเนินการธุรกิจ]',
  NonEditable: 'ไม่สามารถแก้ไขได้',
  BatchExportToImport: 'การส่งออกเป็นจำนวนมากไปยังการนำเข้า',
  NonSupportImportationThroughEntry: 'บริษัทที่ไม่ใช่ส่วนหนึ่งของกลุ่ม ไม่รองรับการนำเข้าผ่านการส่งออกกลับเข้ามา',
  BatchProcessingForTheReselect: 'การดำเนินการนำส่งแบบกลุ่มจากประเทศที่ส่งออกเป็นประเทศที่นำเข้ารองรับเฉพาะการดำเนินการแบบกลุ่มสำหรับบริการตัวแทนท่าเรือปลายทางเดียวกัน กรุณาเลือกใหม่!!',
  TheNotMeetTheConversion: 'ตัวแทนท่าเรือปลายทางและบริษัทดำเนินการไม่เป็นไปตามเงื่อนไขของการแปลงจากส่งออกเป็นนำเข้า!',
  TheThePortAgentExist: 'สาขาที่เชื่อมต่อกับตัวแทนท่าเรือปลายทางไม่มีอยู่',
  NotForReExport: 'ไม่สามารถส่งออกแล้วนำกลับเข้ามาใหม่ได้',
  ExportFunctionIsNotEnabled: 'ฟังก์ชันการส่งออกเป็นการนำเข้ายังไม่ได้เปิดใช้งาน',
  BatchProgressPleaseReferBelow: 'กระบวนการส่งออกเป็นชุดไปยังการนำเข้าอยู่ระหว่างดำเนินการ โปรดดูผลลัพธ์การดำเนินการด้านล่าง!',
  TheDestinationPortAgentEmpty: 'สาขาที่เชื่อมต่อของตัวแทนท่าเรือปลายทางไม่สามารถว่างเปล่าได้!',
  PleaseAFeeToEdit: 'โปรดเลือกค่าใช้จ่ายหนึ่งรายการเพื่อแก้ไข',
  PleaseFeesYouWantDelete: 'โปรดเลือกค่าใช้จ่ายที่ต้องการลบออก!',
  AreWantToDeleteExpense: 'คุณแน่ใจหรือไม่ว่าต้องการลบค่าใช้จ่ายที่เลือกไว้?',
  ThisFeeIsNotEditable: 'ค่าใช้จ่ายนี้ไม่สามารถแก้ไขได้',
  TheNameCannotBeEmpty: 'ชื่อค่าใช้จ่ายไม่สามารถเว้นว่างได้',
  BillUpTo3Currencies: 'ใบแจ้งหนี้รองรับสกุลเงินได้สูงสุด 3 สกุล!'
}

